import React, { useEffect, useState, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { Modal, Button, Row, Container, Col } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import { Context } from '../Context/DataContext';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import BackButton from '../Components/BackButton';
import { FaPrint } from 'react-icons/fa'


const ViewOrder = () => {

    const [loading, setLoading] = useState(false)
    const [ordersItems, setOrderItems] = useState([])
    const { state } = useContext(Context)

    const location = useLocation();


    function getOrderItems() {

        console.log('location')
        console.log(location.state)


        setLoading(true)
        apiRequest({ o_id: location.state.o_id }, 'viewOrderById')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    setOrderItems(data.data)
                    setLoading(false)
                }
                else {
                    alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false);
                alert('Internet error');
            })
    }


    useEffect(() => {
        $(document).ready(function () {
            $('#dataTable').DataTable({ searching: false, paging: false, info: false ,sort:false});
        });

    }, [loading])

    useEffect(() => {
        getOrderItems();
    }, [])

    // const OrderDetailView = () => (

    // )


    return (
        <div id="page-top">
            <div id="wrapper">
                <Sidebar />

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    {/* Main Content */}
                    <div id="content">
                        <Topbar />

                        {/* Begin Page Content */}
                        <div className="container-fluid">
                            <Modal

                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Heading */}
                            <div className="container-fluid">
                                {/* Page Heading */}
                                <div style={{ width: "100%", height: 65 }}>
                                    <div style={{ float: "left", width: "90%" }}>
                                        <h1 className="h3 mb-2 text-gray-800">Orders Details</h1>
                                        <br />
                                    </div>
                                    <Button
                                        style={{backgroundColor:'#f6f6f6',borderWidth:0}}
                                        // className="btn btn-primary btn-user btn-block rBBtn"
                                        onClick={() => {
                                            var mywindow = window.open('', 'PRINT', 'height=600,width=500');
                                            mywindow.document.write('<html><head>');
                                            mywindow.document.write('</head><body><div id="page-top"><div id="wrapper"> <div id="content-wrapper" className="d-flex flex-column"><div id="content"><div className="container-fluid">');
                                            mywindow.document.write(document.getElementById('printDivId').innerHTML);
                                            mywindow.document.write('</div></div></div></div></div> </body></html>');
                                            mywindow.document.close(); // necessary for IE >= 10
                                            mywindow.focus(); // necessary for IE >= 10*/
                                            mywindow.print();
                                            mywindow.close();
                                            return true;


                                        }}>
                                        <FaPrint name="FaPrint" size={30} color="black" />
                                    </Button>
                                    {/* <div style={{ float: "right", textAlign: "right", width: "50%" }}>
                                        <a
                                            href="add_order.php"
                                            className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                                        >
                                            <i className="fas fa-folder-plus fa-sm text-white-50" /> Add
                                            Order
                                        </a>
                                    </div> */}
                                </div>

                                <div id="printDivId">
                                    <Container>
                                        <Row className="col-12" >
                                            <Col className="col-sm-12 col-md-3 mt-2 ">
                                                <Row className="row" style={{ fontSize: 13, fontFamily: 'PMe', }}>Name: {location?.state?.cust_fname} {location?.state?.cust_lname}</Row>
                                                <Row className="row" style={{ fontSize: 13, fontFamily: 'PMe', }}>Phone: {location?.state?.cust_phone}</Row>
                                                {/* <Row className="row" style={{ fontSize: 13, fontFamily: 'PMe', }}>Address: 03134081068</Row> */}
                                            </Col>
                                            <Col className="col-sm-12 col-md-6 mt-2 "></Col>
                                            <Col className="col-sm-12 col-md-3 mt-2">
                                                <Row className="row" style={{ fontSize: 13, fontFamily: 'PMe', }}>Order id: {location?.state?.o_id}</Row>
                                                <Row className="row" style={{ fontSize: 13, fontFamily: 'PMe', }}>Order Date: {location?.state?.o_datetime}</Row>
                                                {/* <Row className="row" style={{ fontSize: 13, fontFamily: 'PMe', }}>Discount: {location?.state?.prom_amount}</Row> */}
                                                <Row className="row" style={{ fontSize: 13, fontFamily: 'PMe', }}>Order Amount: {location?.state?.o_amount}</Row>
                                            </Col>
                                        </Row>
                                    </Container>
                                    <div className="card shadow mb-4 mt-3" style={{ width: "100%" }} >
                                        <div className="card-body">
                                            {
                                                !loading &&

                                                <div className="table-responsive">
                                                    <table
                                                        id="dataTable"
                                                        className="table table-striped table-bordered dt-responsive"
                                                        style={{ width: "100%" }}
                                                    >
                                                        <thead>
                                                            <tr>
                                                                <th className="tRow" >Product Name</th>
                                                                <th className="tRow" >Unit Price</th>
                                                                <th className="tRow" >Quantity</th>
                                                                <th className="tRow" >Discount</th>
                                                                <th className="tRow" >Product Expiry</th>
                                                                <th className="tRow" >Total</th>
                                                                {/* <th class="tRow" >Status1</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {
                                                                ordersItems.map((v) => {
                                                                    return (
                                                                        <tr>
                                                                            <td className="tData">
                                                                                <nobr>
                                                                                    {v.oi_prod}
                                                                                </nobr>
                                                                            </td>
                                                                            <td className="tData">{v.oi_unit_price}</td>
                                                                            <td className="tData">{v.oi_qty}<nobr /></td>
                                                                            <td className="tData">{v.oi_discount}<nobr /></td>
                                                                            <td className="tData">{v.p_exp_days}<nobr /></td>
                                                                            
                                                                            <td className="tData">{v.oi_amount}</td>

                                                                        </tr>

                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>





                                <BackButton />
                            </div>
                        </div>
                        {/* /.container-fluid */}
                    </div>
                    {/* End of Main Content */}
                </div>
                {/* End of Content Wrapper */}
            </div>
            {/* End of Page Wrapper */}
            {/* Scroll to Top Button*/}
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up" />
            </a>
            {/* Logout Modal*/}
            <div
                className="modal fade"
                id="logoutModal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Ready to Leave?
                            </h5>
                            <button
                                className="close"
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Select "Logout" below if you are ready to end your current session.
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                type="button"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <a className="btn btn-primary" href="logout.php">
                                Logout
                            </a>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default ViewOrder
